import { apiFetch } from '../client';

export function fetchPosts(data){
    return apiFetch(`/cms-api/posts/?pagesize=${data.pagesize}&pagenr=${data.pageNr}&category=${data.category}`, {
        method: 'GET'
    })
}

export function fetchPostContentById(postId){
    return apiFetch(`/cms-api/post-content/${postId}/`, {
        method: 'GET'
    })
}
